<template>
    <el-dialog title="销售控制" :visible.sync="visible" :before-close="handleClose">
        <div class="sales-rule-dialog">
            <SalesRuleTeam 
                :defaultExpandAll="true" 
                :treeWidth="600"
                :data="teamData"
            >
                <template v-slot:extra="{ data }">
                    <el-switch v-model="data.checked" active-color="#f5222d" inactive-color="#8c8c8c" active-text="已销售"
                        inactive-text="未销售" v-if="!data.children" :disabled="true" />
                    <!-- <div v-if="!data.children">{{ data.checked ? '已销售' : '未销售' }}</div> -->
                </template>
            </SalesRuleTeam>
        </div>
    </el-dialog>
</template>
<script>
import SalesRuleTeam from "./salesRuleTeam.vue"
import { regionTree } from '@/api/supplierManagement/index'
import _ from 'lodash'
import {
    querySaleAreaListById
} from "@/api/saleRule/agent"
export default {
    name: 'SalesControlDialog',
    components: {
        SalesRuleTeam
    },
    data() {
        return {
            visible: false,
            teamData: [],
            savedTree: []
        }
    },
    methods: {
        publicOpen(e) {
            const { salePlanId } = e;
            if (!salePlanId) return;
            this.visible = true;
            this.requestSelectedRegion(salePlanId)
        },
        handleClose() {
            this.savedTree = [];
            this.teamData = [];
            this.visible = false;
        },
        // 获取省市区树
        requestRegionTree(ids) {
            regionTree().then(res => {
                if (res && res.data && res.data.length > 0) {
                    let resp = _.cloneDeep(res.data);
                    const trees = this.filterTree( resp ,  ids );
                    console.log('trees', trees);
                    this.teamData = trees;
                }
            })
        },
        // 获取已经设置的区域
        requestSelectedRegion(id) {
            querySaleAreaListById(id).then(res => {
                if (res && res.length > 0) {
                    let resp = _.cloneDeep(res);
                    resp.forEach(item => {
                        item.checked = item.saleStatus === 1
                    })
                    this.savedTree = resp;
                    const ids = resp.map(item => Number(item.areaCode));
                    this.requestRegionTree(ids);
                }
            })
        },
        filterTree(tree, ids){
            return tree.filter((node) => {
                // 检查当前节点的ID是否在ids数组中
                if (ids.includes(node.id)) {
                    const savedNode = this.savedTree.find(item => Number(item.areaCode) === node.id);
                    // 如果当前节点在ids数组中，递归过滤其子节点
                    if (node.children) {
                        node.children = this.filterTree(node.children, ids);
                    }
                    node.checked = savedNode.checked;
                    // 保留当前节点
                    return true;
                } else {
                // 如果当前节点不在ids数组中，检查是否有子节点在ids数组中
                if (node.children) {
                    const filteredChildren = this.filterTree(node.children, ids);
                    // 如果有子节点在ids数组中，保留当前节点并替换其子节点为过滤后的子节点
                    if (filteredChildren.length > 0) {
                        node.children = filteredChildren;
                        return true;
                    }
                }
                // 否则，不保留当前节点
                return false;
                }
            });
        }
    }
}
</script>
<style scoped lang="scss"></style>